<template>
  <el-popover
    trigger="click"
    placement="left"
    :disabled="instructorAjaxing"
    v-model="showPlaylistActionMenu"
    @show="handlePopoverShow">
    <div class="action-button" v-if="LTIlaunch">
      <!-- link button-->
      <div class="action-button" v-if="LTIdata.contentId === null">
        <v-btn @click="handleDialogOpen({ type: 'lti', data: { ...playlist, type: 'playlist'} })" flat text class="branded-grey">
          <img class="lms-img-sm" :src="LMSdata.img || 'https://cdn.playposit.com/image-uploads/image-22-05-2019-15-35-00--lms_default.png'">
          <span class="pl-1">Link Playlist</span>
        </v-btn>
      </div>
       <div class="action-button" v-if="LTIdata.render_path === 'playlist' && LTIdata.contentId === playlist.id">
        <v-btn @click="setDashModal({ type: 'confirmUnlink' })" flat text class="branded-grey">
          <img class="lms-img-sm" :src="LMSdata.img || 'https://cdn.playposit.com/image-uploads/image-22-05-2019-15-35-00--lms_default.png'">
          <span class="pl-1">Unlink Playlist</span>
        </v-btn>
      </div>
    </div>
    <div class="action-button" v-if="teacher.playlistTeacher.playlistRole < 3">
      <v-btn
        @click="instructorData.migrated ? null : editPlaylist()"
        :disabled="!!instructorData.migrated"
        flat
        text
        :class="instructorData.migrated ? null : 'branded-grey'"
      >
        <v-icon
          small
          class="pr-1"
        >
          edit
        </v-icon>
        Edit
      </v-btn>
    </div>
    <div class="action-button">
      <v-btn flat @click="previewPlaylist()" text class="branded-grey">
        <v-icon small class="pr-1">play_circle_outline</v-icon>
        Preview
      </v-btn>
    </div>
    <div class="action-button">
      <v-btn flat @click="monitorPlaylist(playlist)" text class="branded-grey">
        <v-icon small class="pr-1">view_list</v-icon>
        Monitor
      </v-btn>
    </div>
    <div class="action-button" v-if="teacher.playlistTeacher.playlistRole < 4 && !LTIlaunch">
      <v-btn
        @click="instructorData.migrated ? null : assignPlaylist()"
        :disabled="!!instructorData.migrated"
        flat
        text
        :class="instructorData.migrated ? null : 'branded-grey'"
      >
        <v-icon
          small
          class="pr-1"
        >
          assignment
        </v-icon>
        Assign
      </v-btn>
    </div>
    <div class="action-button" v-if="teacher.playlistTeacher.playlistRole < 4">
      <v-btn
        @click="instructorData.migrated ? null : managePlaylistPermissions()"
        :disabled="!!instructorData.migrated"
        flat
        text
        :class="instructorData.migrated ? null : 'branded-grey'"
      >
        <v-icon
          small
          class="pr-1"
        >
          group
        </v-icon>
        Collaborate
      </v-btn>
    </div>
    <div class="action-button" v-if="teacher.playlistTeacher.playlistRole > 1">
      <v-btn flat @click="removeAccessFromPlaylist()" text class="branded-grey">
        <v-icon small class="pr-1">person_add_disabled</v-icon>
        Remove Access
      </v-btn>
    </div>
    <div class="action-button" v-if="teacher.playlistTeacher.playlistRole < 3">
      <v-btn
        @click="instructorData.migrated ? null : handleDuplicatePlaylist()"
        :disabled="!!instructorData.migrated"
        flat
        text
        :class="instructorData.migrated ? null : 'branded-grey'"
      >
        <v-icon
          small
          class="pr-1"
        >
          content_copy
        </v-icon>
        Duplicate
      </v-btn>
    </div>
    <div class="action-button" v-if="teacher.playlistTeacher.playlistRole < 2">
      <v-btn
        @click="instructorData.migrated ? null : copyPlaylistLink()"
        :disabled="!!instructorData.migrated"
        flat
        text
        :class="instructorData.migrated ? null : 'branded-grey'"
      >
        <v-icon
          small
          class="pr-1"
        >
          link
        </v-icon>
        Share a copy
      </v-btn>
    </div>
    <div class="action-button" v-if="teacher.playlistTeacher.playlistRole < 2">
      <v-btn flat @click="deletePlaylist(playlist)" text class="branded-grey">
        <v-icon small class="pr-1">delete</v-icon>
        Delete
      </v-btn>
    </div>
    <div slot="reference">
      <v-icon
        v-if="actionColumn"
        tabindex="-1"
        class="hover-white cursor padding branded-text mr-2"
        aria-label="playlist action menu">
          more_vert
      </v-icon>
      <v-icon
        v-else
        tabindex="-1"
        class="cursor"
        large
        :color="playlist.defaultColor"
        aria-label="playlist icon">
          playlist_play
      </v-icon>
    </div>
  </el-popover>
</template>

<script>
/* global _ */
import { 
  mapActions,
  mapState,
  mapGetters,
  mapMutations
} from 'vuex';
import Hashids from 'hashids';
const hashids = new Hashids('dachshund', 6, 'cdefhjkmnprtvwxy2345689');

export default {
  name: 'PlaylistTableActionMenu',
  components: {  },
  props: [
    'actionColumn',
    'handlePopoverShow',
    'playlist',
  ],
  data() {
    return {
      showPlaylistActionMenu: false,
    };
  },
  computed: {
    ...mapState('instructors', [
      'instructorAjaxing',
    ]),
    ...mapGetters([
      'instructorData',
      'LMSdata',
      'LTIdata',
      'LTIlaunch',
      'nodeApiPrefix',
    ]),
    playlistHash() {
      return hashids.encode([this.playlist.id]);
    },
    teacher() {
      return _.find(this.playlist.teachers, { 'id': this.instructorData.id });
    },
  },
  methods: {
    ...mapActions('instructors', [
      'removePlaylistAccess'
    ]),
    ...mapMutations([
      'handleDialogOpen',
      'setDashModal',
    ]),
    assignPlaylist() {
      this.setDashModal({ type: 'playlistAssign', playlist: this.playlist });
      this.showPlaylistActionMenu = false; // el-popover is dumb and won't close
    },
    deletePlaylist() {
      this.setDashModal({ type:'confirmDeletePlaylist', playlist: this.playlist });
      this.showPlaylistActionMenu = false; // el-popover is dumb and won't close
    },
    copyPlaylistLink() {
      this.setDashModal({ type:'copyPlaylistLink', playlist: this.playlist });
      this.showPlaylistActionMenu = false; // el-popover is dumb and won't close
    },
    async handleDuplicatePlaylist() {
      this.setDashModal({ type:'duplicatePlaylist', playlist: this.playlist });
      this.showPlaylistActionMenu = false; // el-popover is dumb and won't close
    },
    editPlaylist() {
      const lmsLaunch = this.LTIlaunch ? '&lms_launch=true' : '';
      window.open(`${this.nodeApiPrefix}/course/${this.playlistHash}?token=${this.instructorData.token}${lmsLaunch}`, '_blank');
      this.showPlaylistActionMenu = false; // el-popover is dumb and won't close
    },
    managePlaylistPermissions() {
      this.setDashModal({ type: 'playlistCollaborate', playlist: this.playlist });
      this.showPlaylistActionMenu = false; // el-popover is dumb and won't close
    },
    monitorPlaylist(playlist) {
      this.setDashModal({ type:'playlistMonitor', playlist });
      this.showPlaylistActionMenu = false; // el-popover is dumb and won't close
    },
    previewPlaylist() {
      window.open(`${this.nodeApiPrefix}/course/${this.playlistHash}?token=${this.instructorData.token}&preview=true`, '_blank');
      this.showPlaylistActionMenu = false; // el-popover is dumb and won't close
    },
    async removeAccessFromPlaylist() {
      await this.removePlaylistAccess(this.playlist.id);
    }
  },
};
</script>
